var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.398,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#9083E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97 22.998a2.184 2.184 0 0 1-.887-.511 2.113 2.113 0 0 1-.546-.853c-.624-1.67-.809-8.64.393-10.016a2.33 2.33 0 0 1 1.572-.767c3.223-.339 13.183-.293 14.327.113.321.102.615.273.86.502.244.228.431.508.55.817.68 1.726.704 7.997-.093 9.655a2.157 2.157 0 0 1-1.006.993c-1.201.586-13.575.575-15.17.067Zm5.118-3.27 5.778-2.933-5.777-2.955v5.887Z",
    fill: "#fff"
  })));
};
export default SvgYoutube;